import { isServerSide } from '../server.js';

const getGpcSignal = () => {
  return isServerSide ? void 0 : navigator.globalPrivacyControl;
};

export { getGpcSignal };
